import CoordTrans from './CoordTrans';
import { bd09togcj02, gcj02tobd09, gcj02towgs84, wgs84togcj02 } from './Utils/CoordTransTools';
export default {
    CoordTrans: CoordTrans,
    bd09togcj02: bd09togcj02,
    gcj02tobd09: gcj02tobd09,
    wgs84togcj02: wgs84togcj02,
    gcj02towgs84: gcj02towgs84
};
